import { Map } from 'immutable';
import {
  FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS,
} from './actions';
import RAv2HomeworkResultSummary from './model';

export default function rav2HomeworkResultSummary(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_RAV2_HOMEWORK_RESULT_SUMMARY_SUCCESS:
      return state.set(action.groupId, toGroupSummaryMap(action.payload));
    default:
      return state;
  }
}

function toGroupSummaryMap(payload) {
  const list = normalizePayload(payload);
  let summaryByStudentId = new Map({});

  list.forEach((item) => {
    if (! item) {
      return;
    }

    const normalized = normalizeApiItem(item);
    if (! normalized || ! normalized.studentId) {
      return;
    }

    summaryByStudentId = summaryByStudentId.set(
      `${normalized.studentId}`,
      RAv2HomeworkResultSummary.create(normalized)
    );
  });

  return summaryByStudentId;
}

function normalizeApiItem(item) {
  const studentId = (item.studentGeneralInfo && item.studentGeneralInfo.id) || item.studentId;
  if (! studentId) {
    return null;
  }

  return {
    studentId,
    avgCompletion: Math.round((item.averageCompletion || 0) * 100),
    avgAccuracy: Math.round((item.averageAccuracy || 0) * 100),
    totalRecorded: item.totalRecorded || 0,
    totalStoryRead: item.totalStoryRead || 0,
  };
}

function normalizePayload(payload) {
  if (! payload) {
    return [];
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  return [];
}



// WEBPACK FOOTER //
// ./data/RAv2HomeworkResultSummary/reducer.js